// internal
import { axios, handleError } from './internal';

function MfaStatus(onSuccess) {
    axios
        .post('/api/mfa_status')
        .then((res) => {
            onSuccess?.(res.data.data);
        })
        .catch((err) => {
            handleError(err);
        });
}

export { MfaStatus };
